var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCardMasterColored(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 15,
    viewBox: "0 0 22 15",
    width: 22,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    transform: "translate(0 .000013)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 .00003897h22v15.00000003h-22z",
    fill: "#0a2540"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.25,
    cy: 7.5,
    fill: "#ed0006",
    r: 4.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14.25,
    cy: 7.5,
    fill: "#f9a000",
    r: 4.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11.25 4.15c.9516888.85355972 1.4954202 2.07161202 1.4954202 3.35s-.5437314 2.49644028-1.4954202 3.35c-.9425819-.8337744-1.4905371-2.0258933-1.50956597-3.28417717-.01902886-1.25828387.49262747-2.4664271 1.40956597-3.32832283z",
    fill: "#ff5d00"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardMasterColored);
export default __webpack_public_path__ + "static/media/cardMasterColored.418d88685e5e5861c55994a5ee654259.svg";
export { ForwardRef as ReactComponent };